import { render, staticRenderFns } from "./print.vue?vue&type=template&id=4b1e77d9&"
import script from "./print.vue?vue&type=script&lang=js&"
export * from "./print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmtkpv/Projects/barcode-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4b1e77d9', component.options)
    } else {
      api.reload('4b1e77d9', component.options)
    }
    module.hot.accept("./print.vue?vue&type=template&id=4b1e77d9&", function () {
      api.rerender('4b1e77d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/routes/template/asides/print.vue"
export default component.exports